var _desc, _rect, _rect2, _rect3, _text, _text2, _line, _text3, _line2, _text4, _text5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTuitionFeesReference(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Registration reference reminder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A red bordered reminder card showing the registration reference location before payment.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    rx: 28,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 1244,
    height: 684,
    rx: 18,
    fill: "#ffffff",
    stroke: "#d40000",
    strokeWidth: 26
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 1184,
    height: 624,
    rx: 16,
    fill: "#ffffff",
    stroke: "#d40000",
    strokeWidth: 12
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 118,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 32,
    fontWeight: 400,
    fill: "#111111"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 640,
    dy: 0
  }, "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0432\u0430\u0448 \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043A\u043E\u0434 \u043F\u0435\u0440\u0435\u0434 \u043E\u043F\u043B\u0430\u0442\u043E\u044E"), /*#__PURE__*/React.createElement("tspan", {
    x: 640,
    dy: 38
  }, "(\u0437\u043D\u0430\u0445\u043E\u0434\u0438\u0442\u044C\u0441\u044F \u0432 \u043E\u0441\u0442\u0430\u043D\u043D\u044C\u043E\u043C\u0443 \u0440\u044F\u0434\u043A\u0443 \u043B\u0438\u0441\u0442\u0430 \u043F\u0440\u043E \u0443\u0441\u043F\u0456\u0448\u043D\u0443"), /*#__PURE__*/React.createElement("tspan", {
    x: 640,
    dy: 38
  }, "\u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044E)"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 232,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 28,
    fontWeight: 700,
    fill: "#d40000"
  }, "\u041F\u0440\u0438\u043A\u043B\u0430\u0434 \u043F\u043E\u043A\u0430\u0437\u0430\u043D\u043E \u043D\u0438\u0436\u0447\u0435")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 260,
    x2: 1120,
    y2: 260,
    stroke: "#222222",
    strokeWidth: 5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 362,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 58,
    fontWeight: 400,
    fill: "#333333"
  }, "Your sign-up reference is: 728a1f")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 406,
    x2: 1120,
    y2: 406,
    stroke: "#222222",
    strokeWidth: 5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 458,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 26,
    fontWeight: 700,
    fill: "#d40000"
  }, "Example shown above")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 542,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 29,
    fontWeight: 400,
    fill: "#111111"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 640,
    dy: 0
  }, "Please confirm your registration reference before payment"), /*#__PURE__*/React.createElement("tspan", {
    x: 640,
    dy: 38
  }, "(You can find it in the last line of your registration confirmation"), /*#__PURE__*/React.createElement("tspan", {
    x: 640,
    dy: 38
  }, "email)"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuitionFeesReference);
export default __webpack_public_path__ + "static/media/tuition-fees-reference.5796dfe18897a9be65e5d5df773b1054.svg";
export { ForwardRef as ReactComponent };